import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ClassValue, mergeClasses } from '../../utils/merge-classes';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  template: '{{ text() }}',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'tooltip',
    '[id]': 'id()',
    '[class]': 'classes()',
  },
})
export class TooltipComponent {
  readonly id = input.required<string>();
  readonly text = input('');
  readonly tooltipClass = input<ClassValue>(null);

  readonly classes = computed(() =>
    mergeClasses(
      'block rounded bg-inverse-surface px-2 py-1 body-small text-inverse-on-surface whitespace-nowrap pointer-events-none',
      this.tooltipClass(),
    ),
  );
}
